import { AirportSearchViewModel } from '@api/index';
import {
  FlightGuestProps,
  FlightTripType,
} from '@components/views/flight/types';
import { DateType } from '@utils/dateUtil';

import { FlightSearchBarQuery } from '../hooks/useFlightQuery';

export interface IFlightSearchBarState {
  startDate?: DateType | null;
  endDate?: DateType | null;
  guestInfo?: FlightGuestProps;
  arrivalAirport?: AirportSearchViewModel | null;
  departureAirport?: AirportSearchViewModel | null;
  flightTripType?: FlightTripType;
  isOneWay?: boolean;
  isDirectFlight?: boolean;
  isValidFlightSearchBar?: boolean;
  isSubmit?: boolean;
  cabinClass: 'All' | 'Business' | 'Economy';
  isDrawerOpen: boolean;
  isDepartureError: boolean;
  isArrivalError: boolean;
}

export enum FlightSearchBarActionType {
  SET_START_DATE = 'SetFlightStartDate',
  SET_END_DATE = 'SetFlightEndDate',
  SET_GUESTS = 'SetFlightGuests',
  SET_ARRIVAL_AIRPORT = 'SetFlightArrivalAirport',
  SET_DEPARTURE_AIRPORT = 'SetFlightDepartureAirport',
  SET_IS_ONE_WAY = 'SetFlightIsOneWay',
  SET_IS_DIRECT_FLIGHT = 'SetFlightIsDirectFlight',
  SET_IS_VALID_FLIGHT_SEARCH_BAR = 'SetFlightIsValidFlightSearchBar',
  SET_IS_SUBMIT = 'SetFlightIsSubmit',
  SET_CABIN_CLASS = 'SetFlightCabinClass',
  SET_ALL = 'SetFlightAll',
  SET_IS_DRAWER_OPEN = 'SetFlightIsDrawerOpen',
  SET_IS_ARRIVAL_ERROR = 'SetIsArrivalError',
  SET_IS_DEPARTURE_ERROR = 'SetIsDepartureError',
}

export interface SetIsDepartureError {
  type: FlightSearchBarActionType.SET_IS_DEPARTURE_ERROR;
  payload: IFlightSearchBarState['isDepartureError'];
}
export interface SetIsArrivalError {
  type: FlightSearchBarActionType.SET_IS_ARRIVAL_ERROR;
  payload: IFlightSearchBarState['isArrivalError'];
}
export interface SetStartDate {
  type: FlightSearchBarActionType.SET_START_DATE;
  payload: IFlightSearchBarState['startDate'];
}

export interface SetEndDate {
  type: FlightSearchBarActionType.SET_END_DATE;
  payload: IFlightSearchBarState['endDate'];
}

export interface SetGuests {
  type: FlightSearchBarActionType.SET_GUESTS;
  payload: IFlightSearchBarState['guestInfo'];
}

export interface SetArrivalAirport {
  type: FlightSearchBarActionType.SET_ARRIVAL_AIRPORT;
  payload: IFlightSearchBarState['arrivalAirport'];
}

export interface SetDepartureAirport {
  type: FlightSearchBarActionType.SET_DEPARTURE_AIRPORT;
  payload: IFlightSearchBarState['departureAirport'];
}

export interface SetIsOneWay {
  type: FlightSearchBarActionType.SET_IS_ONE_WAY;
  payload: IFlightSearchBarState['isOneWay'];
}

export interface SetIsDirectFlight {
  type: FlightSearchBarActionType.SET_IS_DIRECT_FLIGHT;
  payload: IFlightSearchBarState['isDirectFlight'];
}

export interface SetIsValidFlightSearchBar {
  type: FlightSearchBarActionType.SET_IS_VALID_FLIGHT_SEARCH_BAR;
  payload: IFlightSearchBarState['isValidFlightSearchBar'];
}

export interface SetIsSubmit {
  type: FlightSearchBarActionType.SET_IS_SUBMIT;
  payload: IFlightSearchBarState['isSubmit'];
}
export interface SetCabinClass {
  type: FlightSearchBarActionType.SET_CABIN_CLASS;
  payload: IFlightSearchBarState['cabinClass'];
}

export interface SetFlightAll {
  type: FlightSearchBarActionType.SET_ALL;
  payload: FlightSearchBarQuery;
}

export interface SetIsDrawerOpen {
  type: FlightSearchBarActionType.SET_IS_DRAWER_OPEN;
  payload: IFlightSearchBarState['isDrawerOpen'];
}

export type FlightSearchBarActions =
  | SetStartDate
  | SetEndDate
  | SetGuests
  | SetArrivalAirport
  | SetDepartureAirport
  | SetIsOneWay
  | SetIsDirectFlight
  | SetIsValidFlightSearchBar
  | SetIsSubmit
  | SetCabinClass
  | SetFlightAll
  | SetIsDrawerOpen
  | SetIsDepartureError
  | SetIsArrivalError;
